import React from 'react';
import i18n from 'i18n';
import Button from 'react-bootstrap/Button';
import { TransactionListState, WizardTransactionListState } from 'store/transactions/transactionsTypes';
import WizardTransactionTable from 'components/modal/wizard/WizardTransactionTable';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { ServiceType, WizardTransactionTypes } from 'components/modal/wizard/WizardTransactionTypes';
import BzmIcon from '../../icons/BzmIcon';
import ElevioTooltip from '../../overlays/helpTooltip/TitleHelpTooltip/ElevioTooltip';

interface BehaviorProps {
  idOrName: ServiceType;
  service: number | string;
  transactions: WizardTransactionListState;
  wizardTransactionActions: (action: WizardTransactionTypes, payload: any) => void;
  validTransaction: boolean;
}

const Behavior = (props: BehaviorProps) => {
  const headerText = `(${props.transactions.transactions.length})`;

  const addTransaction = () => {
    //if a new transaction is being edited do not add another one
    if (props.transactions.isCreatingNewTransaction !== true) {
      props.wizardTransactionActions('add', null);
    }
  };

  return (
    <div>
      <h2 className={'mb-5'}>{i18n.t('wizard:details.behavior.title')}</h2>
      <p dangerouslySetInnerHTML={{ __html: i18n.t('wizard:details.behavior.description') }} />
      <p dangerouslySetInnerHTML={{ __html: i18n.t('wizard:details.behavior.description2') }} />

      <h2 className="mb-3">
        <Row>
          <Col style={{ textAlign: 'start' }}>
            <span className="mr-2" title={`${i18n.t('transactions:table.txnsAllCaps')} ${headerText}`}>
              {i18n.t('transactions:table.txnsAllCaps')} {headerText}
            </span>
            <ElevioTooltip id={'TransactionsHelpId'} elevioId={'Transactions_heading_help'} />
          </Col>
          <Col style={{ textAlign: 'end' }}>
            {!props.validTransaction ? (
              <OverlayTrigger
                delay={200}
                rootClose={true}
                placement="top"
                overlay={<Tooltip id="tooltip-disabled">{i18n.t('wizard:tooltip.behavior')}</Tooltip>}
              >
                <span className="btn disabled mb-3" onClick={(event: any) => event.preventDefault()}>
                  <BzmIcon variant={'icon-bzm-add'} /> {i18n.t('wizard:details.behavior.addTransaction')}
                </span>
              </OverlayTrigger>
            ) : (
              <Button variant="primary" className={'mb-3'} onClick={addTransaction}>
                <BzmIcon variant={'icon-bzm-add'} /> {i18n.t('wizard:details.behavior.addTransaction')}
              </Button>
            )}
          </Col>
        </Row>
      </h2>
      <WizardTransactionTable
        wizardTransactionActions={props.wizardTransactionActions}
        transactions={props.transactions}
        serviceId={-2}
      />
    </div>
  );
};

export default Behavior;
